/*
 * JS helpers for common workspace features.
 */

export const ERRORS_BLOCK = '.form-results-errors';
export const SUCCESS_BLOCK = '.form-results-success';

export function show_error(msg){
    showBlock(ERRORS_BLOCK, msg);
}

export function show_success(msg){
    showBlock(SUCCESS_BLOCK, msg);
}

export function showBlock(selector, msg) {
    hide_messages();
    if ($(selector).length == 0) {
        console.log('HTML issue. Can\'t find ' + selector + ' block!');
        return false;
    }
    $(selector + " .content").html(msg);
    $(selector).first().fadeIn();
}

export function remove_flash(){
  $('.flash').fadeOut("slow");
  $('.flash').remove();
}

export function hide_messages() {
    $(ERRORS_BLOCK).hide();
    $(SUCCESS_BLOCK).hide();
}

export function check_auth_status(code) {
    if(code == 401) { document.location = signin_users_path }
}

export function initWorkspaceScripts() {
	checkboxesGroupController();
	validNum();
	inputFile();
  $('#flash').fadeIn();
}

// Allows to check/uncheck all checkboxes which has name = {groupName}.
// The name {groupName} is given as a value of parameter "name" for element 'input#check-all'.
export function checkboxesGroupController() {
	$('input#check-all').on('change', function() {
		var groupName = $(this).val();
		var selector = 'input[name="' + groupName + '"]';

		if ($(this).is(':checked')) {
			$(selector).prop('checked', true);
		} else {
			$(selector).prop('checked', false);
		}

        tableCheckboxesController();
	});
}

export function tableCheckboxesController() {
    $("input[name='item_ids[]']").on('change',function(){
        var flag = true;
        $('input[name$="_ids[]"]').each(function() {
            if($(this).not(':checked'))
                flag = false;
        });
        $('input#check-all').prop('checked',flag);
    });
}

// Disabling wrapper for changeControlState().
export function disableControls(selector) {
	changeControlState(selector, false);
}

// Disables all controls who are child for selector.
// Use for loading process.
export function changeControlState(selector, state) {
	$(selector).find('input[type="submit"]').each(function(){
		if (state) {
			$(this).removeAttr('disabled');
		} else {
			$(this).attr('disabled', 'disabled');
		}
	});
}

export function validNum() {
    $("#advanced_send_badge_counter").keydown(function(event) {
            // Allow: backspace, delete, tab, escape, and enter
                if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
                    // Allow: Ctrl+A
                    (event.keyCode == 65 && event.ctrlKey === true) ||
                    // Allow: home, end, left, right
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                     // let it happen, don't do anything
                     return;
            }
            else {
                // Ensure that it is a number and stop the keypress
                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                    event.preventDefault();
                }
            }
        });
}

export function inputFile() {
  $(".inputFile").attr('size','12').on('change',function(){
        var filename_input_id = $(this).attr('id');
        var file = $(this).val().replace(/^.*[\\\/]/, '');
        if ($('#fileName-'+filename_input_id).length) {
          $(this).parents('form').find('#fileName-'+filename_input_id).val(file);
        } else {
          $(this).parents('form').find('.fileName').val(file);
        };
  });
}

export function registerWorkspaceValidators() {
  $.validator.addMethod('isDate', function(value, element) {
    var matcher = /^([1-2]\d{3}-([0]?[1-9]|1[0-2])-([0-2]?[0-9]|3[0-1])) (20|21|22|23|[0-1]?\d{1}):([0-5]?\d{1}):([0-5]?\d{1})$/i
    return matcher.test(value);
  });
}

export function scrollToContainer() {
  $.scrollTo('#container', 'slow');
}

export function htmlEscape(str) {
    return String(str)
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
}

export function dataTruncate(str, length) {
  if (!str) return ""

  const maxLength = length === undefined ? 50 : length
  let shortStr
  let longStr = ""

  if (str.length >= maxLength) {
    shortStr = `${str.substring(0, maxLength)}...`
  } else {
    shortStr = str
  }

  for (let i = 0; i < str.length; i += 50) {
    longStr += `${str.substring(i, i + 50)}\n`
  }

  return `<span title="${longStr}">${shortStr}</span>`
}
